import { IPOAvatar } from "../../../styles/index";
import { Popover } from "antd"
import React, { FC } from "react"
import { ITag, TagEnum } from "../tag"
import { TagCardWrap } from "./style";


interface ITagCardProps {
  tag: ITag;
  baseUrl: string;
  size?: number;
  zIndex?: number;
  isMargin?: boolean;
  isBox?: boolean;
}

export const TagCard: FC<ITagCardProps> = ({ tag, baseUrl, size = 22, zIndex = 99998, isMargin = false, isBox = false }) => {
  const tagPopEl = () => {
    return (
      <>
        <div className="tag-info">
          <span>名称：</span>{tag.name ? tag.name : "-"}
        </div>
        <div className="tag-info">
          <span>描述：</span>{tag.desc ? tag.desc : "-"}
        </div>
      </>
    )
  };

  return <TagCardWrap isMargin={isMargin} isBox={isBox}>
    <Popover
      zIndex={zIndex}
      key={tag.id}
      placement={'top'}
      content={() => tagPopEl()}
      title={tag.type === TagEnum.TEAM ? "团队标签信息" : '专业标签信息'}
      trigger={['click']}
      getPopupContainer={() => document.body as HTMLElement}
    >
      <div>
        <IPOAvatar size={size} info={{
          avatar: tag.icon,
          name: tag.name,
          id: tag.id,
          name2: tag.name,
          mobile: tag.name,
          baseUrl: baseUrl ?? ''
        }} />
      </div>
    </Popover>
  </TagCardWrap>

}